// extracted by mini-css-extract-plugin
module.exports = {"top-logo":"index_top-logo_1ZetU","dropdown":"index_dropdown_1fupo","icon":"index_icon_1wGRI","title":"index_title_2i_3U"};